import React, { useEffect, useState} from "react";
import { NavLink } from "react-router-dom";
import "../index.css";
import AttachmentIcon from "@mui/icons-material/Attachment";
import GskLogo from "../assests/gsk-logo.png";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LoadingButton from "@mui/lab/LoadingButton";
import Collapse from "@mui/material/Collapse";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import SnackBarComponent from "../components/Helpers/SnackBarComponent";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import homeIcon from "../assests/home-icon.svg";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import sidebarLogo from "../assests/gsk_1.svg";
import miniLogo from "../assests/mini-gsk.png";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import MailIcon from "@mui/icons-material/Mail";
import { styled, useTheme } from "@mui/material/styles";
import LogoutIcon from "@mui/icons-material/Logout";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import Avatar from "@mui/material/Avatar";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { Outlet } from "react-router-dom";
import axiosRequest from "../api/axios";
import ApprovalIcon from '@mui/icons-material/Approval';
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import {baseURL} from "../api/constant"
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const drawerWidth = 220;
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  height: "auto",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 2,
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
};
const Sidebar = (props) => {
  let { Authenticated } = props;
  const theme = useTheme();
  const [open3, setOpen3] = React.useState(true);
  const [openRbm, setOpenRbm] = React.useState(true);
  const [openRbm1, setOpenRbm1] = React.useState(true);
  const [openAbm, setOpenAbm] = React.useState(true);
  const [openAbm1, setOpenAbm1] = React.useState(true);
  const [openRephq, setOpenRephq] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [selectedgrowth, setSelectedGrowth] = React.useState(false);
  const [selectedsku, setSelectedSku] = React.useState(false);
  const [selectedbu, setSelectedBu] = React.useState(false);
  const [selectedgrowthrbmrole, setSelectedGrowthrbmrole] =
    React.useState(false);
  const [selectedskurbmrole, setSelectedSkurbmrole] = React.useState(false);
  const [selectedreprole, setSelectedreprole] = React.useState(false);
  const [selectedskuabmrole, setSelectedSkuabmrole] = React.useState(false);
  const [selectedskurephqrole, setSelectedSkurephqrole] = React.useState(false);
  const [selectedburbmrole, setSelectedBurbmrole] = React.useState(false);
  const [selectedbrandrbmrole, setSelectedBrandrbmrole] = React.useState(false);
  const [selectedRephq, setSelectedRephq] = React.useState(false);
  const [selected, setSelected] = React.useState(true);
  const [selectedRbm, setSelectedRbm] = React.useState(true);
  const [selectedRbmSum, setselectedRbmSum] = React.useState(false);
  const [selectedRbm1, setSelectedRbm1] = React.useState(true);
  const [selectedAbm, setSelectedAbm] = React.useState(true);
  const [selectedAbm1, setSelectedAbm1] = React.useState(true);
  const [adminopen, setAdminopen] = React.useState(true);
  const [adminselected, setAdminselected] = React.useState(true);
  const [logoutselected, setLogoutselected] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openanchor = Boolean(anchorEl);
  const username = localStorage.getItem("username");
  const [selected4, setSelected4] = React.useState(true);
  const [open4, setOpen4] = React.useState(true);
  const navigate = useNavigate();
  const [showOverviewModal, setshowOverviewModal] = React.useState(false);
  const [documentlink, setDocumentLink] = React.useState('');
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [file, setFile] = React.useState("");
  const [loaderUpload, setloaderUpload] = useState(false);
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = useState(false);

  const [selectedFileName, setselectedFileName] = React.useState("");
  var formData = new FormData();
  const changeHandler = (event) => {
    // console.log("FILE CHANGED");
    let img = event.target.files[0];
    // var filename="ptl.csv";

    formData.append("file", img);
    // console.log(event.target.files[0].name, "FORM DATAA");
    setFile(formData);
    setIsFilePicked(true);

    setselectedFileName(event.target.files[0].name);
  };
  const handleCloseSnack = () => {
    setOpensb(false);
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };
  const api_headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("Token"),
  };
  const UploadFile = () => {
    if (file != "") {
      setloaderUpload(true);
      axiosRequest({
        url: "admin_app/uploaddocument/",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("Token"),
        },
        data: file,
      }).then((data) => {
        if (data.status === 200) {
          setIsFilePicked(false);
          handleSnackBar("uploaded successfully", "success");
          setloaderUpload(false);
          formData = new FormData();
          // formData.append("source_name", "");
          setFile("");
        } else {
          handleSnackBar("upload failed", "error");
          setloaderUpload(false);
          formData = new FormData();
          setFile("");
        }
        // setIsFileUploaded(response.data['any_duplicates'])

        // if (response.data['Status'] === "Success") {
        //   let text = "Data insertion is Success\n"+(response.data['message'])+"\nTotal Records: "+(response.data['total_records_count'])+"\nInserted Records: "+(response.data['inserted_records_count'])+"\nDuplicates: "+(response.data['duplicates_count'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("success")
        // } else {
        //   console.log("else alert")
        //   let text = "Data insertion is failed  \n"+(response.data['message'])+"\nthis are the columns: "+(response.data['columns'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("error")

        // }
      });
    } else {
      handleSnackBar("Please Select file before uploading", "warning");
    }
  };
  // API to get Quater and Year
  const getDocument = async () => {
    await axiosRequest({
      url: "admin_app/getdocumentlink/",
      method: "GET",
      headers: api_headers,
      // https://b3.gsk.com/api/
    }).then((data) => {
      if (data.status === 200) {
        setDocumentLink("https://b3.gsk.com/api/"+data?.data?.data)
        console.log(data?.data?.data, "DATAA");
        // setfiltersOutputData()
      } else {
      }
    });
  };
  const downloadDocument = async () => {
    await axiosRequest({
      url: "admin_app/downloaddocument/",
      method: "GET",
      headers: api_headers,
    }).then(function (response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      ); 
      let name = documentlink.split('/')
      console.log(name[-1],"nameee")
      let temp_file_name = name[name.length -1];
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", temp_file_name);
      document.body.appendChild(link);
      link.click();
    });
  };
  useEffect(() => {
        if (
          localStorage.getItem("Token") != "" ||
          localStorage.getItem("Token") != null
        ) {
          getDocument();
        }
  },[])
  React.useEffect(() => {
    handleDrawerClose()
  }, []);
  const handleClick = () => {
    setOpen3(!open3);
    setSelected(!selected);
  };

  const handleClickApproval = () => {
    setSelected4(!selected4);
    setOpen4(!open4)
  };
  const handleClickAnchor = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleLogout = () => {
    setLogoutselected(!logoutselected);

    // Authenticated=false
    localStorage.removeItem("ROLE");
    localStorage.removeItem("username");
    localStorage.removeItem("Auth");
    localStorage.removeItem("email");
    localStorage.removeItem("teamcode");
    localStorage.removeItem("Token");
    localStorage.removeItem("quarter");
    localStorage.removeItem("year");
    navigate("/login");
    handleClose();
  };
  const [selected3, setSelected3] = React.useState(false);
  const [selectedbrand, setSelectedBrand] = React.useState(false);

  const handleClick3 = () => {
    setSelected3(!selected3);
    setOpen1(false);
    setSelected1(false);
    setSelectedGrowth(false);
    setSelectedSku(false);
    setSelectedBu(false);
  };

  const handleClick4 = () => {
    setSelected3(!selected3);
    setOpen1(false);
    setSelected1(false);
    setSelectedGrowth(false);
    setSelectedSku(false);
    setSelectedBu(false);
  };
  const handleClickGrowth = () => {
    setSelectedGrowth(!selectedgrowth);
    setOpen3(false);
    setSelected(false);
    setSelectedSku(false);
    setSelectedBu(false);
    setSelected3(false);
    setselectedRbmSum(false)
  };

  const handleClickBUHBrand = () => {
    setSelectedBrand(!selectedbrand);
    setOpen3(false);
    setSelected(false);
    setSelectedSku(false);
    setSelectedBu(false);
    setSelected3(false);
    setselectedRbmSum(false)
  };
  const handleClickSku = () => {
    setselectedRbmSum(false)
    setSelectedSku(!selectedsku);
    setOpen3(false);
    setSelected(false);
    setSelectedGrowth(false);
    setSelectedBu(false);
    setSelected3(false);
  };
  const handleRBMSum = () => {
    setselectedRbmSum(!selectedRbmSum);
    setOpen3(false);
    setSelected(false);
    setSelectedGrowth(false);
    setSelectedBu(false);
    setSelected3(false);
    setSelectedSku(false);
  };
  const handleClickBu = () => {
    setSelectedBu(!selectedbu);
    setselectedRbmSum(false)
    setOpen3(false);
    setSelected(false);
    setSelectedSku(false);
    setSelectedGrowth(false);
    setSelected3(false);
  };

  const handleClickGrowthRbmRole = () => {
    setSelectedGrowthrbmrole(!selectedgrowthrbmrole);
    setSelectedBurbmrole(false);
    setSelectedSkurbmrole(false);
    setOpen3(false);
    setSelected(false);
    setSelectedSku(false);
    setSelectedBu(false);
    setSelected3(false);
  };
  const handleClickSkuRbmRole = () => {
    setSelectedSkurbmrole(!selectedskurbmrole);
    setSelectedGrowthrbmrole(false);
    setSelectedBurbmrole(false);
    setSelectedBrandrbmrole(false);
    setOpen3(false);
    setSelected(false);
    setSelectedGrowth(false);
    setSelectedBu(false);
    setSelected3(false);
    setSelectedreprole(false);
  };

  const handleClickRephqRbmRole = () => {
    setSelectedreprole(!selectedreprole);
    setSelectedGrowthrbmrole(false);
    setSelectedBurbmrole(false);
    setSelectedBrandrbmrole(false);
    setOpen3(false);
    setSelected(false);
    setSelectedGrowth(false);
    setSelectedBu(false);
    setSelected3(false);
  };
  const handleClickSkuAbmRole = () => {
    setSelectedSkuabmrole(!selectedskuabmrole);
    setSelectedGrowthrbmrole(false)
    setSelectedAbm1(false);
    setOpenAbm1(false);
    setSelectedAbm(false);
    setOpenAbm(false);
    setOpen1abmrole(false);
    setSelected1abmrole(false);
    setSelectedBurbmrole(false)
    setSelectedBrandrbmrole(false);
  };
  const handleClickSkuRephqRole = () => {
    setSelectedSkurephqrole(!selectedskurephqrole);
    setOpenRephq(false);
    setSelectedRephq(false);

    // setSelectedAbm1(false)
    // setOpenAbm1(false)
    // setSelectedAbm(false)
    // setOpenAbm(false)
    // setOpen1abmrole(false);
    // setSelected1abmrole(false);
  };
  const handleClickBuRbmRole = () => {
    setSelectedBurbmrole(!selectedburbmrole);
    setSelectedSkurbmrole(false);
    setSelectedGrowthrbmrole(false);
    setOpen3(false);
    setSelected(false);
    setSelectedSku(false);
    setSelectedGrowth(false);
    setSelected3(false);
  };
  const handleClickBrandRbmRole = () => {
    setSelectedBrandrbmrole(!selectedbrandrbmrole);
    setSelectedBurbmrole(false);
    setSelectedSkurbmrole(false);
    setSelectedGrowthrbmrole(false);
    setOpen3(false);
    setSelected(false);
    setSelectedSku(false);
    setSelectedGrowth(false);
    setSelected3(false);
  };

  const adminhandleClick = () => {
    setAdminopen(!adminopen);
    setAdminselected(!adminselected);
  };
  const handleClickABMbtn = () => {
    setSelectedAbm(!selectedAbm);
    setOpenAbm(!openAbm);
  };
  const handleClickABMbtn1 = () => {
    setSelectedAbm1(!selectedAbm1);
    setOpenAbm1(!openAbm1);
  };
  const handleClickREPHQbtn = () => {
    setSelectedRephq(!selectedRephq);
    setOpenRephq(!openRephq);
  };
  const handleClickRBMbtn = () => {
    setSelectedRbm(!selectedRbm);
    setOpenRbm(!openRbm);
  };
  const handleClickRBMbtn1 = () => {
    setSelectedRbm1(!selectedRbm1);
    setOpenRbm1(!openRbm1);
  };

  const handleCloseOverviewModal = () => {
    setshowOverviewModal(false);
  };

  const handleOverviewModal = () => {
    setshowOverviewModal(true);
    
   
  };
  const Role = localStorage.getItem("ROLE");
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const [open1, setOpen1] = React.useState(true);
  const [selected1, setSelected1] = React.useState(true);
  const [open1rbmrole, setOpen1rbmrole] = React.useState(true);
  const [selected1rbmrole, setSelected1rbmrole] = React.useState(true);
  const [open1abmrole, setOpen1abmrole] = React.useState(true);
  const [selected1abmrole, setSelected1abmrole] = React.useState(true);
  const [open1rephqrole, setOpen1rephqrole] = React.useState(true);
  const [selected1rephqrole, setSelected1rephqrole] = React.useState(true);
  const handleClick1 = () => {
    setOpen1(!open1);
    setSelected1(!selected1);
  };
  const handleClick1RBMRole = () => {
    setOpen1rbmrole(!open1rbmrole);
    setSelected1rbmrole(!selected1rbmrole);
  };
  const handleClick1ABMRole = () => {
    setOpen1abmrole(!open1abmrole);
    setSelected1abmrole(!selected1abmrole);
  };
  const handleClick1REPHQRole = () => {
    setOpen1rephqrole(!open1rephqrole);
    setSelected1rephqrole(!selected1rephqrole);
  };

  const handleClose = () => {
    setAnchorEl(false);
  };

  const handleDrawerClose = () => {
    if (open) {
      
      if (Role === "BUH") {
        setOpen3(false);
        setSelected(false);
        setOpen1(false);
        setSelected1(false);
        setOpen4(false);
        setSelected4(false);
      }
      if (Role === "RBM") {
        setOpen1rbmrole(false);
        setSelected1rbmrole(false);
        setOpenRbm(false);
        setSelectedRbm(false);
        setOpenRbm1(false);
        setSelectedRbm1(false);
      }
      if (Role === "ABM") {
        setOpenAbm(false);
        setSelectedAbm(false);
        setOpenAbm1(false);
        setSelectedAbm1(false);
        setOpen1abmrole(false);
        setSelected1abmrole(false);
      }
      if (Role === "REPHQ") {
        // setOpenAbm(false);
        // setSelectedAbm(false);
        // setOpenAbm1(false);
        // setSelectedAbm1(false);
        // setOpen1abmrole(false);
        // setSelected1abmrole(false);
        setOpenRephq(false);
        setSelectedRephq(false);
        setOpen1rephqrole(false);
        setSelected1rephqrole(false);
      }
      
      
      if (Role === 'ADMIN') {
        setAdminopen(false);
        setAdminselected(false);
      }
      
      setOpen(false);
    } else {
      setOpen(true);
      if (Role === "BUH") {
        setOpen3(true);
        setSelected(true);
        setOpen1(true);
        setSelected1(true);
        setOpen4(true);
        setSelected4(true);
      }
      if (Role === "RBM") {
        setOpen1rbmrole(true);
        setSelected1rbmrole(true);
        setOpenRbm(true);
        setSelectedRbm(true);
        setOpenRbm1(true);
        setSelectedRbm1(true);
      }
      if (Role === "ABM") {
        setOpenAbm(true);
        setSelectedAbm(true);
        setOpenAbm1(true);
        setSelectedAbm1(true);
        setOpen1abmrole(true);
        setSelected1abmrole(true);
      }
      if (Role === "REPHQ") {
        // setOpenAbm(false);
        // setSelectedAbm(false);
        // setOpenAbm1(false);
        // setSelectedAbm1(false);
        // setOpen1abmrole(false);
        // setSelected1abmrole(false);
        setOpenRephq(true);
        setSelectedRephq(true);
        setOpen1rephqrole(true);
        setSelected1rephqrole(true);
      }
      if (Role === 'ADMIN') {
        setAdminopen(true);
        setAdminselected(true);
        
      }
      
     
      
     
      
    }
  };
  return (
    <div style={{ display: "flex" }}>
      <Drawer
        style={{ display: window.location.pathname === "/login" ? "none" : "" }}
        variant="permanent"
        open={open}
      >
        <DrawerHeader
          sx={{ display: "flex", flexDirection: open ? "row" : "column" }}
        >
          {open ? (
            <img
              src={sidebarLogo}
              className="bg-white"
              alt=""
              style={{ margin: "auto", width: "100px" }}
            />
          ) : (
            ""
          )}
          {!open ? (
            <img
              src={miniLogo}
              className="bg-white"
              alt=""
              style={{ margin: "10px", width: "38px", borderRadius: "25px" }}
            />
          ) : (
            ""
          )}
          <IconButton onClick={handleDrawerClose}>
            {!open ? <MenuOpenIcon /> : <MenuOpenIcon />}
          </IconButton>
        </DrawerHeader>
        <div
          className="side-bar bg-white"
          style={{ paddingLeft: open ? "5px" : "", paddingRight: "5px" }}
        >
          <div style={{ height: "84vh" }}>
            <div
              style={{
                textAlign: "center",
                height: open === true ? "15%" : "10%",
              }}
            >
              <Button
                id="fade-button"
                aria-controls={openanchor ? "fade-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openanchor ? "true" : undefined}
                onClick={handleClickAnchor}
                sx={{
                  bgcolor: "grey",
                  color: "black",
                  margin: "0px",
                }}
                className="profile__icon__button"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "auto",
                  }}
                >
                  <Avatar alt={username} src="/static/images/avatar/1.jpg" />
                  <p
                    style={{
                      display: open === true ? "" : "none",
                      fontWeight: 500,
                      fontSize: "smaller",
                      marginTop: "4px",
                    }}
                  >
                    {username}
                  </p>
                </div>
              </Button>

              <Menu
                id="fade-menu"
                MenuListProps={{
                  "aria-labelledby": "fade-button",
                }}
                anchorEl={anchorEl}
                open={openanchor}
                onClose={handleClose}
                TransitionComponent={Fade}
              >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </div>
            {open ? (
              <p
                style={{
                  marginLeft: "20px",
                  fontWeight: "500",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
              >
                Menu
              </p>
            ) : (
              ""
            )}

            {Role === "BUH" ? (
              <div>
              <List
                sx={{
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton
                  onClick={handleClick}
                  style={{
                    backgroundColor: selected ? "#FF680A" : "",
                    color: selected ? "white" : "black",
                    borderRadius: selected ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <HomeOutlinedIcon
                      fontSize="medium"
                      style={{
                        color: selected ? "white" : "grey",
                        marginBottom: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Budget Allocation"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  {open3 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open3} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/rbmlevelbudget"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rbmlevelbudget"
                            ? "#FF680A"
                            : "black",
                      }}
                     
                      exact
                    >
                      <ListItemButton>
                        <ListItemText sx={{ pl: 7, pt: 0 }} primary="Budget Template" />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
              <List
                sx={{
                  bgcolor: "background.paper",
                  marginTop:"-13px"
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton
                  onClick={handleClickApproval}
                  style={{
                    backgroundColor: selected4 ? "#FF680A" : "",
                    color: selected4 ? "white" : "black",
                    borderRadius: selected4 ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <ApprovalIcon
                      fontSize="medium"
                      style={{
                        color: selected4 ? "white" : "grey",
                        marginBottom: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Approval"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  {open4 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open4} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/commercialheadbuh"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/commercialheadbuh"
                            ? "#FF680A"
                            : "black",
                      }}
                      
                      exact
                    >
                      <ListItemButton>
                        <ListItemText sx={{ pl: 7, pt: 0 }} primary="RBM Approval" />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
              </div>
            ) : (
              ""
            )}
            {Role === "RBM" ? (
              <div>
                <List
                  sx={{
                    bgcolor: "background.paper",
                 
                  }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  <ListItemButton
                    onClick={handleClickRBMbtn1}
                    style={{
                      backgroundColor: selectedRbm1 ? "#FF680A" : "",
                      color: selectedRbm1 ? "white" : "black",
                      borderRadius: selectedRbm1 ? "10px" : "",
                    }}
                  >
                    <ListItemIcon>
                      <HomeOutlinedIcon
                        fontSize="medium"
                        style={{
                          color: selectedRbm1 ? "white" : "grey",
                          marginBottom: "3px",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="Budget Allocation"
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                    {openRbm1 ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openRbm1} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <NavLink
                        to="/abmlevelbudget"
                        className="navlink"
                        activeclassname="active"
                        style={{
                          color:
                            window.location.pathname === "/abmlevelbudget"
                              ? "#FF680A"
                              : "black",
                        }}
                        exact
                      >
                        <ListItemButton>
                          <ListItemText
                            sx={{ pl: 7, pt: 0 }}
                            primary="Budget Template"
                          />
                        </ListItemButton>
                      </NavLink>
                    </List>
                  </Collapse>
                </List>
                <List
                  sx={{
                    bgcolor: "background.paper",
                    marginLeft: "3px",
                    marginTop: "-13px",
                  }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  <ListItemButton
                    onClick={handleClickRBMbtn}
                    style={{
                      backgroundColor: selectedRbm ? "#FF680A" : "",
                      color: selectedRbm ? "white" : "black",
                      borderRadius: selectedRbm ? "10px" : "",
                    }}
                  >
                    <ListItemIcon>
                      <PersonAddAltIcon
                        fontSize="medium"
                        style={{
                          color: selectedRbm ? "white" : "grey",
                          marginBottom: "3px",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="RBM"
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                    {openRbm ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openRbm} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <NavLink
                        to="/abmselection"
                        className="navlink"
                        activeclassname="active"
                        style={{
                          color:
                            window.location.pathname === "/abmselection"
                              ? "#FF680A"
                              : "black",
                        }}
                        exact
                      >
                        <ListItemButton>
                          <ListItemText
                            sx={{ pl: 7, pt: 0 }}
                            primary="ABM Selection"
                          />
                        </ListItemButton>
                      </NavLink>
                    </List>
                  </Collapse>
                </List>
              </div>
            ) : (
              ""
            )}
            {Role === "ABM" ? (
              <div>
                 <List
                  sx={{
                    bgcolor: "background.paper",
                    marginLeft: "3px",
                  }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  <ListItemButton
                    onClick={handleClickABMbtn1}
                    style={{
                      backgroundColor: selectedAbm1 ? "#FF680A" : "",
                      color: selectedAbm1 ? "white" : "black",
                      borderRadius: selectedAbm1 ? "10px" : "",
                    }}
                  >
                    <ListItemIcon>
                      <GroupsIcon
                        fontSize="medium"
                        style={{
                          color: selectedAbm1 ? "white" : "grey",
                          marginBottom: "3px",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="Budget Allocation"
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                    {openAbm1 ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openAbm1} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <NavLink
                        to="/abmandrephqlevelbudget"
                        className="navlink"
                        activeclassname="active"
                        style={{
                          color:
                            window.location.pathname === "/abmandrephqlevelbudget"
                              ? "#FF680A"
                              : "black",
                        }}
                        exact
                      >
                        <ListItemButton>
                          <ListItemText
                            sx={{ pl: 7, pt: 0 }}
                            primary="Budget Template"
                          />
                        </ListItemButton>
                      </NavLink>
                    </List>
                  </Collapse>
                </List>
                <List
                  sx={{
                    bgcolor: "background.paper",
                    marginTop: "-13px",
                    marginLeft: "3px",
                  }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  <ListItemButton
                    onClick={handleClickABMbtn}
                    style={{
                      backgroundColor: selectedAbm ? "#FF680A" : "",
                      color: selectedAbm ? "white" : "black",
                      borderRadius: selectedAbm ? "10px" : "",
                    }}
                  >
                    <ListItemIcon>
                      <PersonAddAltIcon
                        fontSize="medium"
                        style={{
                          color: selectedAbm ? "white" : "grey",
                          marginBottom: "3px",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="ABM"
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                    {openAbm ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openAbm} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <NavLink
                        to="/rephqselection"
                        className="navlink"
                        activeclassname="active"
                        style={{
                          color:
                            window.location.pathname === "/rephqselection"
                              ? "#FF680A"
                              : "black",
                        }}
                        exact
                      >
                        <ListItemButton>
                          <ListItemText
                            sx={{ pl: 7, pt: 0 }}
                            primary="REPHQ Selection"
                          />
                        </ListItemButton>
                      </NavLink>
                    </List>
                  </Collapse>
                </List>
               
              </div>
            ) : (
              ""
            )}
            {Role === "REPHQ" ? (
              <List
                sx={{
                  bgcolor: "background.paper",
                  marginTop: "5px",
                  marginLeft: "3px",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton
                  onClick={handleClickREPHQbtn}
                  style={{
                    backgroundColor: selectedRephq ? "#FF680A" : "",
                    color: selectedRephq ? "white" : "black",
                    borderRadius: selectedRephq ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <GroupsIcon
                      fontSize="medium"
                      style={{
                        color: selectedRephq ? "white" : "grey",
                        marginBottom: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="REPHQ" sx={{ opacity: open ? 1 : 0 }} />
                  {openRephq ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openRephq} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/rephqlevelbudget"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rephqlevelbudget"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Budget Template"
                        />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
            ) : (
              ""
            )}
            {Role === "BUH" ? (
              <List
                sx={{ width: "100%", bgcolor: "background.paper" }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{ marginTop: "-11px", marginLeft: "-2px" }}
              >
                <ListItemButton
                  onClick={handleClick1}
                  style={{
                    backgroundColor: selected1 ? "#FF680A" : "",
                    color: selected1 ? "white" : "black",
                    borderRadius: selected1 ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <SummarizeOutlinedIcon
                      fontSize="medium"
                      style={{
                        color: selected1 ? "white" : "grey",
                        marginBottom: "3px",
                        marginLeft: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Reports"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  {open1 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open1} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/growthsummary"
                      className="navlink"
                      activeclassname="active"
                     
                      style={{
                        color:
                          window.location.pathname === "/growthsummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Growth Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/skusummary"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/skusummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="SKU Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/brandsummary"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/brandsummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Brand Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/rbmsummary"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rbmsummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="RBM Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/bubudget"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/bubudget"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="BUH Budget"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/historicalbudgetdata"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/historicalbudgetdata"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Historical Budget Data"
                        />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
            ) : (
              ""
            )}
            {Role === "RBM" ? (
              <List
                sx={{ width: "100%", bgcolor: "background.paper" }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{ marginTop: "-11px" }}
              >
                <ListItemButton
                  onClick={handleClick1RBMRole}
                  style={{
                    backgroundColor: selected1rbmrole ? "#FF680A" : "",
                    color: selected1rbmrole ? "white" : "black",
                    borderRadius: selected1rbmrole ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <SummarizeOutlinedIcon
                      fontSize="medium"
                      style={{
                        color: selected1rbmrole ? "white" : "grey",
                        marginBottom: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Reports"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  {open1rbmrole ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open1rbmrole} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/abmgrowthsummary"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/abmgrowthsummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="ABM Growth Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/rephqgrowthsummary"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rephqgrowthsummarys"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="REPHQ Growth Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                    {/* <NavLink
                      to="/rbmskusummary"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rbmskusummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="SKU Summary"
                        />
                      </ListItemButton>
                    </NavLink> */}
                    <NavLink
                      to="/rbmbubudget"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rbmbubudget"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="RBM Budget"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/rbmbrand"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rbmbrand"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Brand Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/adjustedcheckabm"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/adjustedcheckabm"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Adjusted Check ABM"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/adjustedcheckrephq"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/adjustedcheckrephq"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Adjusted Check REPHQ"
                        />
                      </ListItemButton>
                    </NavLink>
                     <NavLink
                      to="/rbmhistoricaldata"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/rbmhistoricaldata"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Historical Data"
                        />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
            ) : (
              ""
            )}
            {Role === "ABM" ? (
              <List
                sx={{ width: "100%", bgcolor: "background.paper" }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{ marginTop: "-11px", marginLeft: "2px" }}
              >
                <ListItemButton
                  onClick={handleClick1ABMRole}
                  style={{
                    backgroundColor: selected1abmrole ? "#FF680A" : "",
                    color: selected1abmrole ? "white" : "black",
                    borderRadius: selected1abmrole ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <SummarizeOutlinedIcon
                      fontSize="medium"
                      style={{
                        color: selected1abmrole ? "white" : "grey",
                        marginBottom: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Reports"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  {open1abmrole ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open1abmrole} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/abmskusummary"
                      className="navlink"
                      activeclassname="active"
                      
                      style={{
                        color:
                         
                          window.location.pathname === "/abmskusummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Brand Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                  </List>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/replevelsummary"
                      className="navlink"
                      activeclassname="active"
                      
                      style={{
                        color:
                     
                          window.location.pathname === "/replevelsummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Rep Level Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
            ) : (
              ""
            )}
            {Role === "REPHQ" ? (
              <List
                sx={{ width: "100%", bgcolor: "background.paper" }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{ marginTop: "-11px", marginLeft: "3px" }}
              >
                <ListItemButton
                  onClick={handleClick1REPHQRole}
                  style={{
                    backgroundColor: selected1rephqrole ? "#FF680A" : "",
                    color: selected1rephqrole ? "white" : "black",
                    borderRadius: selected1rephqrole ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <SummarizeOutlinedIcon
                      fontSize="medium"
                      style={{
                        color: selected1rephqrole ? "white" : "grey",
                        marginBottom: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Reports"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  {open1rephqrole ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open1rephqrole} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/rephqbrandsummary"
                      className="navlink"
                      activeclassname="active"
                    
                      style={{
                        color:
                          window.location.pathname === "/rephqbrandsummary"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Brand Summary"
                        />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
            ) : (
              ""
            )}

            {Role === "ADMIN" ? (
              <List
                sx={{ bgcolor: "background.paper" }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{ marginTop: "2px", marginLeft: "2px" }}
              >
                <ListItemButton
                  onClick={adminhandleClick}
                  style={{
                    backgroundColor: adminselected ? "#FF680A" : "",
                    color: adminselected ? "white" : "black",
                    borderRadius: adminselected ? "10px" : "",
                  }}
                >
                  <ListItemIcon>
                    <AdminPanelSettingsIcon
                      fontSize="medium"
                      style={{
                        color: adminselected ? "white" : "grey",
                        marginBottom: "3px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Admin"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  {adminopen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={adminopen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <NavLink
                      to="/admin/user"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/user"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText sx={{ pl: 7, pt: 0 }} primary="Users" />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/approval"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/approval"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText sx={{ pl: 7, pt: 0 }} primary="Approval Tables" />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/templates"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/templates"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText sx={{ pl: 7, pt: 0 }} primary="Template Tables" />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/head_count"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/head_count"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="HeadCount"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/product_mapping"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/product_mapping"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Product Mapping"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/product_team_mapping"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/product_team_mapping"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Product Team Mapping"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/placement_changes"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname ===
                          "/admin/placement_changes"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Placement Changes"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/hproductingenium"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/hproductingenium"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="HProductIngenium"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/method"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/method"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Method Table"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/budget"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/budget"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Budget Table"
                        />
                      </ListItemButton>
                    </NavLink>
                    {/* <NavLink
                      to="/admin/awd"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/awd"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="AWD Table"
                        />
                      </ListItemButton>
                    </NavLink> */}
                    <NavLink
                      to="/admin/proxy"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/proxy"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Proxy Table"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/vaccine"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/vaccine"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Vaccine Placement Changes"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/suffix"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/suffix"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Suffix Table"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/factor"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/factor"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Factor Table"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/hyvmeichanges"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/hyvmeichanges"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Hyvmei Changes"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/excludetable"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/excludetable"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Exclude Table"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/yearquarter"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/yearquarter"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Year Quarter"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/teams"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/teams"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Teams Table"
                        />
                      </ListItemButton>
                    </NavLink>
                    <NavLink
                      to="/admin/emails"
                      className="navlink"
                      activeclassname="active"
                      style={{
                        color:
                          window.location.pathname === "/admin/emails"
                            ? "#FF680A"
                            : "black",
                      }}
                      exact
                    >
                      <ListItemButton>
                        <ListItemText
                          sx={{ pl: 7, pt: 0 }}
                          primary="Manage Emails"
                        />
                      </ListItemButton>
                    </NavLink>
                  </List>
                </Collapse>
              </List>
            ) : (
              ""
            )}
                <Modal
        open={showOverviewModal}
        onClose={handleCloseOverviewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1}>
          <CloseIcon
            onClick={handleCloseOverviewModal}
            style={{
              marginLeft: "370px",
              color: "grey",
              alignSelf: "flex-end",
              cursor: "pointer",
            }}
          />
          {/* <h3>Total Overview :{documentlink}</h3> */}
          <div style={{display:"flex",flexDirection:"row",marginTop:"10px"}}>
          <a className="document-view" href={documentlink} target="_blank">Info</a>
          {Role !== 'ADMIN'?(""):(<div style={{display:"flex"}}><Button
                        style={{
                          backgroundColor: "#e5e5e5",
                          color: "black",
                          height: "35px",
                          textTransform: "none",
                          fontSize: "13px",
                          padding:"20px"
                        }}
                        variant="contained"
                        component="label"
                      >
                        <AttachmentIcon
                          size="small"
                          style={{ marginRight: "5px" }}
                        />
                        {isFilePicked ? selectedFileName : "Select File"}
                        <input
                          onChange={changeHandler}
                          onClick={(event) => {
                            event.target.value = null;
                          }}
                          hidden
                          accept="/*"
                          type="file"
                        />
                      </Button>
                      <LoadingButton
                        onClick={UploadFile}
                        loading={loaderUpload}
                        variant="contained"
                        style={{
                          height: "35px",
                          marginLeft: "10px",
                          backgroundColor: "#e5e5e5",
                          textTransform: "none",
                          color: "black",
                          padding:"20px"
                          
                        }}
                      >
                        <FileUploadIcon
                          style={{ display: loaderUpload ? "none" : "" }}
                          fontSize="small"
                        />
                        {loaderUpload ? "" : "Upload"}
                      </LoadingButton>
          </div>)}
                      </div>
          {/* <Button sx={{ ml: 1, width: "180px", height: "35px" }}
                    style={{
                      backgroundColor: "#FF6A0A",
                      color: "white",
                      textTransform: "none",
                    }}
                    variant="contained"
                    component="span"
                    startIcon={
                      <FileDownloadIcon
                        
                        fontSize="small"
                      />
                    } onClick={downloadDocument}>Download Document</Button> */}
        </Box>
      </Modal>
      {open?<div style={{display: "flex",
    flexDirection: "row",
    justifyContent: "center"}}>
      {Role === 'ADMIN'?(<button className="submit-btn" onClick={handleOverviewModal}>info</button>):(<button className="view-btn" ><a  style={{textDecoration:"none",color:"white"}} href={documentlink} target="_blank">Info</a></button>)}
      </div>:""}
      
          </div>
        </div>
      </Drawer>
      <div className="container-outlet">
        <Outlet />
      </div>
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleCloseSnack}
        severity={severity}
        content={content}
      />
    </div>
  );
};

export default Sidebar;
